<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M5 5.48261V14.5174C5 15.6394 6.198 16.355 7.1859 15.823L15.5753 11.3056C16.6151 10.7457 16.6151 9.25431 15.5753 8.69441L7.1859 4.17701C6.198 3.64501 5 4.36061 5 5.48261Z"
            fill="#8E8E93"
        />
    </svg>
</template>
